export function localDateKey(date = new Date()): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export function treatmentEnd(start: string, value: number, unit: string): string {
  const date = new Date(`${start}T12:00:00`);
  // The starting day is day one, not day zero.
  date.setDate(date.getDate() + value * (unit === 'weeks' ? 7 : 1) - 1);
  return localDateKey(date);
}

export function isTreatmentActive(med: { is_active: boolean; start_date: string; end_date: string }, now = new Date()): boolean {
  const today = localDateKey(now);
  return med.is_active && med.start_date <= today && med.end_date >= today;
}

export function scheduledDate(time: string, now = new Date()): Date {
  const date = new Date(now);
  const [hours, minutes] = time.split(':').map(Number);
  date.setHours(hours, minutes, 0, 0);
  return date;
}

export function dayBounds(now = new Date()): [string, string] {
  const start = new Date(now); start.setHours(0, 0, 0, 0);
  const end = new Date(start); end.setDate(end.getDate() + 1);
  return [start.toISOString(), end.toISOString()];
}

export function validateSchedule(times: string[], duration: number, stock: string, threshold: string): boolean {
  const validCount = (value: string) => value === '' || (/^\d+$/.test(value) && Number.isSafeInteger(Number(value)));
  return times.length > 0 && times.length <= 12 && new Set(times).size === times.length
    && times.every(time => /^([01]\d|2[0-3]):[0-5]\d$/.test(time))
    && Number.isSafeInteger(duration) && duration >= 1 && duration <= 3650
    && validCount(stock) && validCount(threshold);
}

export function reminderStage(time: string, now = new Date()): 'soon' | 'due' | null {
  const seconds = (scheduledDate(time, now).getTime() - now.getTime()) / 1000;
  if (seconds > 540 && seconds <= 600) return 'soon';
  if (seconds <= 0 && seconds > -60) return 'due';
  return null;
}
